export default function InvalidLink() {
  return (
    <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4">
      <div className="tw-text-center tw-max-w-md">
        <h1 className="tw-text-2xl tw-font-semibold tw-text-gray-900">
          Lien invalide
        </h1>
        <p className="tw-mt-3 tw-text-gray-600">
          Ce lien n'est pas valide ou a expiré.
        </p>
      </div>
    </div>
  );
}
